module.exports = __webpack_public_path__ + "img/water-splash.7e7f82da.png";